// sortProducts.js

import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import comingSoon from "../../../assets/extras/coming-soon.jpg";

const SortProducts = (props) => {

    const { selectedProducts, handleLoading } = props;

    const [sortOrder, setSortOrder] = useState('Sort By');

    // Reset sortOrder when selectedProducts changes
    useEffect(() => {
        setSortOrder('Sort By');
    }, [selectedProducts]);

    const handleSort = (event) => {
        setSortOrder(event.target.value);
    }

    const sortedProducts = selectedProducts.slice().sort((a, b) => {
        const priceA = parseFloat(a.product.fields.productPrice.replace(/,/g, ''));
        const priceB = parseFloat(b.product.fields.productPrice.replace(/,/g, ''));
        // converting string into number to sort w/o errors

        if (sortOrder === 'lowToHigh') {
            return priceA - priceB;
        } else if (sortOrder === 'highToLow') {
            return priceB - priceA;
        } else {
            // Default sorting order if no specific order is selected
            return 0;
        }
    });

    return(
        <div className="sort-products">
            {selectedProducts.length > 1
            ?
            <div className="sort-products__form">
                <select name="sortProducts" id="sort-products__select" className="sort-products__select" value={sortOrder} onChange={handleSort}>
                    <option value="Sort By">Sort By (Default)</option>
                    <option value="lowToHigh">Price (Low - High)</option>
                    <option value="highToLow">Price (High - Low)</option>
                </select>
                <div className="sort-products__select--arrow"></div>
            </div>
            : null
            }

            <div className="products-category__products">
                {sortedProducts.map((category) => {
                    return(
                        <div key={category.product.id} className="products-category__product">
                            <Link to={category.product.fields.productName.replace(/\s+/g, '-').toLowerCase()}>
                            <div className="products-category__product--image">
                                <div className="loading">
                                    <div className="loading-bar"></div>
                                </div>

                                {category.images[0]
                                ? <img loading="lazy" width={100} height={100} src={category.images[0].fields.file.url} alt={category.images[0].fields.title} onLoad={handleLoading}/>
                                : <img loading="lazy" width={100} height={100} src={comingSoon} alt="coming soon" onLoad={handleLoading}/>}
                            </div>

                            {/* tag */}
                            {/* {category.product.metadata.tags.length
                            ? <div className="products-category__product--tag">{category.product.metadata.tags[0].sys.id}</div>
                            : null
                            } */}

                            {category.product.metadata.tags.length
                            ? <div className="products-category__product--tags">
                                {category.product.metadata.tags.map((tag) => {
                                    return (
                                        <div key={tag.sys.id}className="products-category__product--tags-tag">
                                            {tag.sys.id.replace(/([A-Z])/g, ' $1')}
                                        </div>
                                    )
                                })}
                            </div>
                            : null
                            }

                            <h4 className="products-category__product--name">{category.product.fields.productName}</h4>

                            <div className="products-category__product--details">{category.product.fields.productDetail}</div>

                            <div className="products-category__product--price">Starts At <span>₹{category.product.fields.productPrice}</span></div>
                            </Link>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default SortProducts;